<template>
    <div class="top-table-filter-container">
        <!-- Десктопная версия -->
        <div class="green-filter d-none d-md-flex mb-2 align-items-center">
            <!-- Выпадающий список для выбора "Мои / Отдел" -->
            <b-form-select 
                v-if="!isHeadsAndAccountants && !isAgent"
                size="sm"
                v-model="isForDepartment" 
                class="custom-select-green-dropdown mr-3"
                style="width: 80px;" 
                @change="updateFiltering"
            >
                <b-form-select-option :value="0">Мои</b-form-select-option>
                <b-form-select-option :value="1">Отдел</b-form-select-option>
            </b-form-select>

            <!-- Фильтр статусов -->
            <span v-for="(item, index) in greenFilterMenu" 
                  :key="index" 
                  :class="`mr-3 ${item.active ? 'green-link active' : 'green-link'}`" 
                  @click="changeActive(index)">
                {{ item.title }}
            </span>
        </div>

        <!-- Мобильная версия -->
        <div class="d-flex d-md-none mobile-filter-container">
            <!-- Бургер-меню -->
            <button 
                class="burger-menu-btn"
                @click="toggleMobileMenu"
                :class="{ active: isMobileMenuOpen }"
            >
                <span class="burger-line"></span>
                <span class="burger-line"></span>
                <span class="burger-line"></span>
            </button>

            <!-- Выпадающее меню -->
            <div class="mobile-dropdown" :class="{ show: isMobileMenuOpen }">
                <!-- Выбор "Мои / Отдел" -->
                <div class="mobile-filter-section" v-if="!isHeadsAndAccountants && !isAgent">
                    <h6 class="mobile-filter-title">Область</h6>
                    <div class="mobile-filter-items">
                        <span 
                            :class="`mobile-filter-item ${isForDepartment === 0 ? 'active' : ''}`"
                            @click="isForDepartment = 0; updateFiltering(); closeMobileMenu()"
                        >
                            Мои
                        </span>
                        <span 
                            :class="`mobile-filter-item ${isForDepartment === 1 ? 'active' : ''}`"
                            @click="isForDepartment = 1; updateFiltering(); closeMobileMenu()"
                        >
                            Отдел
                        </span>
                    </div>
                </div>

                <!-- Фильтр статусов -->
                <div class="mobile-filter-section">
                    <h6 class="mobile-filter-title">Статус</h6>
                    <div class="mobile-filter-items">
                        <span 
                            v-for="(item, index) in greenFilterMenu"
                            :key="index"
                            :class="`mobile-filter-item ${item.active ? 'active' : ''}`"
                            @click="changeActive(index); closeMobileMenu()"
                        >
                            {{ item.title }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: {
        api: {type: String, required: true}, // Ссылка на API для работы с таблицей
    },
    data() {
        return {
            isMobileMenuOpen: false,
            isForDepartment: 0, // По умолчанию "Мои"
            greenFilterMenu: [
                {title: "Все", active: true},
                {title: "Новые", active: false, status_id: 311},
                {title: "В работе", active: false, status_id: 312},
                {title: "Выполненные", active: false, status_id: 313},
                {title: "Отмененные", active: false, status_id: 314}
            ]
        };
    },
    computed: {
        ...mapGetters("auth", ["currentUser"]),

        isHeadsAndAccountants() {
            return this.currentUser.role.includes('president') || 
                    this.currentUser.role.includes('head-accountant') || 
                    this.currentUser.role.includes('accountant');
        },

        isAgent() {
            return this.currentUser.role.includes('agent');
        },
    },    
    mounted() {
        this.changeActive(this.$store.state.userLocalSettings.filterSettings.financeRequestsTable);
    },
    methods: {
        changeActive(activeIndex) {
            let additionalParameter = '';

            // Сохраняем выбор в store
            this.$store.dispatch("userLocalSettings/SET_FILTER_SETTINGS", {
                name: 'financeRequestsTable',
                value: activeIndex
            });

            // Обновляем активный статус в фильтре
            this.greenFilterMenu.forEach((item, index) => {
                item.active = activeIndex == index;
                if (activeIndex == index && item.status_id) {
                    additionalParameter += `&status_id=${item.status_id}`;
                }
            });

            // Добавляем параметр "Отдел" если выбран
            if (this.isForDepartment) {
                additionalParameter += '&is_for_department=1';
            }

            this.$emit('setFilteringApiParameter', additionalParameter);
        },
        updateFiltering() {
            // Просто обновляем фильтрацию при изменении dropdown
            const activeIndex = this.greenFilterMenu.findIndex(item => item.active);
            this.changeActive(activeIndex);
        },

        // Методы для мобильного меню
        toggleMobileMenu() {
            this.isMobileMenuOpen = !this.isMobileMenuOpen;
        },

        closeMobileMenu() {
            this.isMobileMenuOpen = false;
        }
    }
};
</script>